<template>
  <div>
    <v-dialog v-model="dialog" max-width="700">
      <!--begin::Modal dialog-->
      <div class="bg-white poppins">
        <!--begin::Modal header-->
        <div class="modal-header py-4 align-center">
          <h4 class="mb-0 font-weight-bolder">
            {{ isEditing ? "Edit WMS Warehouses" : "Add WMS Warehouses" }}
          </h4>
          <!--begin::Close-->
          <div
            class="btn btn-sm btn-icon btn-active-light-info"
            @click="toggleModal"
          >
            <span class="svg-icon">
              <v-icon size="22">mdi-close</v-icon>
            </span>
          </div>
          <!--end::Close-->
        </div>
        <!--end::Modal header-->
        <!--begin::Modal body-->
        <div class="modal-body d-flex flex-column mx-5 py-7">
          <!-- WMS Dropdown (single) -->
          <div class="mb-4">
            <v-autocomplete
              v-model="formData.wms_id"
              label="WMS"
              :items="wmses"
              item-text="text"
              item-value="index"
              dense
              outlined
              clearable
              :error-messages="wmsErrors"
              @change="onWmsChange"
              @blur="$v.formData.wms_id.$touch()"
            />
          </div>

          <!-- Warehouses Dropdown (multiple) -->
          <div class="mb-4">
            <Multiselect
              v-model="formData.warehouse_id"
              :modelValue="formData.warehouse_id"
              class="multi-select-filter-nested-form mb-1"
              placeholder="Warehouses"
              :options="wmsWarehouses"
              label="text"
              track-by="index"
              openDirection="bottom"
              :multiple="true"
              :taggable="false"
              :close-on-select="false"
              ref="warehouses"
            >
              <template #clear>
                <div
                  class="multiselect__clear"
                  v-if="formData.warehouse_id?.length"
                  @click.prevent.stop="
                    () => {
                      formData.warehouse_id = [];
                    }
                  "
                ></div>
              </template>

              <template #beforeList>
                <div class="option__desc mt-1">
                  <button class="multiselect__option" @click="selectAll">
                    <v-icon
                      :color="
                        wmsWarehouses?.length > 0 ? 'primary darken-4' : ''
                      "
                    >
                      {{ icon }}
                    </v-icon>
                    Select all
                  </button>
                </div>
              </template>
            </Multiselect>
            <div
              class="v-text-field__details px-3"
              v-if="$v.formData.warehouse_id.$error"
            >
              <div class="v-messages theme--light error--text" role="alert">
                <div class="v-messages__wrapper">
                  <div
                    v-if="!$v.formData.warehouse_id.notEmpty"
                    class="v-messages__message"
                  >
                    At least one warehouse is required
                  </div>
                  <!--                  <div class="v-messages__message">This field is required</div>-->
                </div>
              </div>
            </div>
            <!--            <v-autocomplete-->
            <!--              v-model="formData.warehouse_id"-->
            <!--              label="Warehouses"-->
            <!--              :items="availableWarehouses"-->
            <!--              item-text="text"-->
            <!--              item-value="index"-->
            <!--              dense-->
            <!--              outlined-->
            <!--              clearable-->
            <!--              multiple-->
            <!--              small-chips-->
            <!--              deletable-chips-->
            <!--              :disabled="!formData.wms_id"-->
            <!--              :error-messages="warehouseErrors"-->
            <!--              @blur="$v.formData.warehouse_id.$touch()"-->
            <!--            >-->
            <!--              <template v-slot:prepend-item v-if="availableWarehouses?.length">-->
            <!--                <v-list-item ripple @click="selectAll">-->
            <!--                  <v-list-item-action>-->
            <!--                    <v-icon-->
            <!--                      :color="-->
            <!--                        availableWarehouses?.length > 0-->
            <!--                          ? 'primary darken-4'-->
            <!--                          : ''-->
            <!--                      "-->
            <!--                    >-->
            <!--                      {{ icon }}-->
            <!--                    </v-icon>-->
            <!--                  </v-list-item-action>-->
            <!--                  <v-list-item-content>-->
            <!--                    <v-list-item-title> Select All </v-list-item-title>-->
            <!--                  </v-list-item-content>-->
            <!--                </v-list-item>-->
            <!--                <v-divider class="mt-2"></v-divider>-->
            <!--              </template>-->
            <!--              <template v-slot:no-data>-->
            <!--                <v-list-item>-->
            <!--                  <v-list-item-content>-->
            <!--                    <v-list-item-title class="max-w-300px text-wrap">-->
            <!--                      No warehouse available. Remove warehouse from another WMS-->
            <!--                      or add a new warehouse.-->
            <!--                    </v-list-item-title>-->
            <!--                  </v-list-item-content>-->
            <!--                </v-list-item>-->
            <!--              </template>-->
            <!--            </v-autocomplete>-->
          </div>

          <!-- Actions -->
          <div class="d-flex flex-grow-1 align-end justify-center mt-2">
            <button
              type="reset"
              class="btn btn-light mr-3 px-5 py-3 ls1"
              @click="resetFormData"
            >
              Clear
            </button>
            <button
              type="submit"
              class="btn btn-info px-5 py-3 ls1"
              @click="submitForm"
            >
              Submit
            </button>
          </div>
          <!--end::Actions-->
        </div>
        <!--end::Modal body-->
      </div>
      <!--end::Modal dialog-->
    </v-dialog>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import Multiselect from "vue-multiselect";

export default {
  name: "AddWMSWarehouse",
  mixins: [validationMixin],
  components: { Multiselect },
  props: {
    actionFunction: {
      type: Function,
      required: true,
    },
    wmses: {
      type: Array,
      default: () => [],
    },
    warehouses: {
      type: Array,
      default: () => [],
    },
    wms_warehouses: {
      type: Array,
      default: () => [],
    },
    existingItems: {
      type: Array,
      default: () => [],
    },
  },
  validations: {
    formData: {
      wms_id: { required },
      warehouse_id: {
        required,
        notEmpty(value) {
          return Array.isArray(value) && value.length > 0;
        },
      },
    },
  },
  data: function () {
    return {
      dialog: false,
      isEditing: false,
      checkbox: false,
      editingOriginalWmsId: null,
      formData: {
        wms_id: null,
        warehouse_id: [],
      },
    };
  },
  computed: {
    icon() {
      if (this.allWarehousesSelected) return "mdi-close-box";
      if (this.someWarehousesSelected) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
    allWarehousesSelected() {
      return this.wms_warehouses?.length === this.formData.warehouse_id?.length;
    },
    someWarehousesSelected() {
      return (
        this.formData.warehouse_id?.length > 0 && !this.allWarehousesSelected
      );
    },
    /**
     * All warehouse IDs already assigned across ANY WMS row in the datatable,
     * excluding the row currently being edited (so existing selections are kept).
     * A warehouse can only belong to one WMS — global uniqueness.
     */
    usedWarehouseIds() {
      return this.existingItems
        .filter((item) => {
          // Exclude the row being edited so user can keep their current warehouses
          if (this.isEditing && item.wms_id === this.editingOriginalWmsId) {
            return false;
          }
          return true;
        })
        .flatMap((item) => item.warehouse_id || []);
    },

    /**
     * Warehouses available for selection = all warehouses minus those
     * already assigned to ANY other WMS row.
     */
    // availableWarehouses() {
    //   return this.warehouses.filter(
    //     (w) => !this.usedWarehouseIds.includes(w.index)
    //   );
    // },
    selectedWMS() {
      return this.formData.wms_id;
    },
    wmsWarehouses() {
      const warehouseByIndex = new Map(
        this.warehouses.map((w) => [w.index, w])
      );
      if (this.selectedWMS) {
        const localWarehouses = this.wms_warehouses
          .find((w) => w.wms_id === this.selectedWMS)
          ?.warehouses.filter((w) => !this.usedWarehouseIds.includes(w));

        // O(k) lookup per item instead of O(k×n) scan
        return localWarehouses?.map((idx) => warehouseByIndex.get(idx));
      } else if (
        Array.isArray(this.wms_warehouses) &&
        Array.isArray(this.wms_warehouses[1]?.warehouses)
      ) {
        // 2 item from wmes should be selected by default
        return this.wms_warehouses[1]?.warehouses.map((idx) =>
          warehouseByIndex.get(idx)
        );
      }
      return [];
    },

    wmsErrors() {
      const errors = [];
      if (!this.$v.formData.wms_id.$dirty) return errors;
      !this.$v.formData.wms_id.required && errors.push("WMS is required");
      return errors;
    },

    warehouseErrors() {
      const errors = [];
      if (!this.$v.formData.warehouse_id.$dirty) return errors;
      if (
        !this.$v.formData.warehouse_id.required ||
        !this.$v.formData.warehouse_id.notEmpty
      ) {
        errors.push("At least one warehouse is required");
      }
      return errors;
    },
  },
  methods: {
    selectAll() {
      this.checkbox = !this.checkbox;
      if (this.checkbox) {
        this.formData.warehouse_id = this.wmsWarehouses.map(
          (item) => item.index
        );
        this.formData.warehouse_id = [...this.wmsWarehouses];
      } else {
        this.formData.warehouse_id = [];
      }
    },
    onWmsChange() {
      // Clear warehouse selection when WMS changes
      this.formData.warehouse_id = [];
      this.$v.formData.warehouse_id.$reset();
    },

    submitForm() {
      this.$v.$touch();
      if (this.$v.$invalid) return;

      this.actionFunction(
        {
          ...this.formData,
          warehouse_id: this.formData.warehouse_id.map((item) => item.index),
        },
        this.isEditing,
        this.editingOriginalWmsId
      );
      this.dialog = false;
    },

    resetFormData() {
      this.$v.$reset();
      this.formData = { wms_id: null, warehouse_id: [] };
    },

    /**
     * @param {Object|null} item - Pass an item to open in edit mode, null for add mode.
     */
    toggleModal(item = null) {
      if (!this.dialog) {
        this.resetFormData();
        if (item) {
          this.isEditing = true;
          this.editingOriginalWmsId = item.wms_id;
          const warehouseByIndex = new Map(
            this?.warehouses.map((w) => [w.index, w])
          );

          // O(k) lookup per item instead of O(k×n) scan
          const selectedWarehouses = item.warehouse_id?.map((idx) =>
            warehouseByIndex.get(idx)
          );

          this.formData = {
            wms_id: item.wms_id,
            // warehouse_id: [...(item.warehouse_id || [])],
            warehouse_id: selectedWarehouses,
          };
        } else {
          this.isEditing = false;
          this.editingOriginalWmsId = null;
        }
      }
      this.dialog = !this.dialog;
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .v-dialog {
  overflow: visible !important;
}
</style>
